import { format } from "date-fns";

export const DUE_GROUPS = [
  { key: "overdue", label: "Overdue" },
  { key: "today", label: "Today" },
  { key: "upcoming", label: "Upcoming" },
  { key: "none", label: "No date" },
];

export function localDay(date = new Date()) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function parseDueDate(dueDate) {
  if (!dueDate) return null;
  const parsed = new Date(`${dueDate}T12:00:00`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function dueUrgency(dueDate, today = localDay()) {
  const due = parseDueDate(dueDate);
  if (!due) return "none";
  const start = localDay(today);
  const dueDay = localDay(due);
  if (dueDay < start) return "overdue";
  if (dueDay.getTime() === start.getTime()) return "today";
  return "upcoming";
}

export function relativeDueLabel(dueDate, today = localDay()) {
  const due = parseDueDate(dueDate);
  if (!due) return "";
  const days = Math.round((localDay(due) - localDay(today)) / 86400000);
  if (days < 0) {
    const overdueDays = -days;
    return overdueDays === 1 ? "Overdue 1 day" : `Overdue ${overdueDays} days`;
  }
  if (days === 0) return "Due today";
  if (days === 1) return "Due tomorrow";
  if (days < 7) return `Due ${format(due, "EEEE")}`;
  return `Due ${format(due, "d MMM yyyy")}`;
}

export function absoluteDueLabel(dueDate) {
  const due = parseDueDate(dueDate);
  return due ? `Due ${format(due, "d MMM yyyy")}` : "";
}

export function groupTasksByDue(items, today = localDay()) {
  const buckets = { overdue: [], today: [], upcoming: [], none: [] };
  items.forEach(item => {
    buckets[dueUrgency(item.due_date, today)].push(item);
  });
  return DUE_GROUPS.map(group => ({ ...group, items: buckets[group.key] })).filter(
    group => group.items.length,
  );
}
